/** Strip tags for safe preview / LLM input from rich HTML. */
export function stripHtml(html: string): string {
  if (!html?.trim()) return '';
  if (typeof document === 'undefined') {
    return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  const d = document.createElement('div');
  d.innerHTML = html;
  return (d.textContent || d.innerText || '').replace(/\s+/g, ' ').trim() || html.replace(/<[^>]+>/g, ' ').trim();
}

function escapeHtmlText(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Turn plain text (paragraphs separated by blank lines) into simple HTML for RichTextEditor. */
export function plainToSimpleHtml(text: string): string {
  const paras = text
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
  if (paras.length === 0) return '';
  return paras
    .map((p) => `<p>${escapeHtmlText(p).replace(/\n/g, '<br/>')}</p>`)
    .join('');
}
